(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('main-product .mn-product-purchase .quantity-selector button');
    if (!button) return;
    const selector = button.closest('.quantity-selector');
    const input = selector.querySelector('input[name="quantity"]');
    const product = button.closest('main-product');
    const variant = product.querySelector('select[name="id"]')?.selectedOptions[0];
    if (!input || !variant) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (variant.dataset.stock !== 'true') return;
    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const current = Number(input.value) || min;
    const increment = button.classList.contains('increment-btn');
    let maximum = input.max ? Number(input.max) : Infinity;
    if (variant.dataset.inventorycheck === 'true' && variant.dataset.continueSelling !== 'true') {
      const stock = Number(variant.dataset.stockcount);
      if (Number.isFinite(stock)) maximum = Math.min(maximum, stock);
    }
    const next = increment ? current + step : current - step;
    if (next < min || next > maximum) return;
    input.value = String(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const minus = selector.querySelector('.decrement-btn');
    if (minus) minus.style.cursor = next <= min ? 'not-allowed' : 'pointer';
  }, true);
})();
